import type { MonitorsUnitType } from '../../components/Main/QueuePanel/QueuePanel';

export type CreatedTicketItemLike = {
  itemId: number;
  itemName: string;
  status: string;
};

export type CreatedTicketsLike = {
  items: CreatedTicketItemLike[];
};

/** Сравнение view табло без учёта audioList (пути кэшируются на бэке и не влияют на UI). */
export const isQueueItemsEqual = (
  oldData: MonitorsUnitType | undefined,
  newData: MonitorsUnitType | undefined
): boolean => {
  if (oldData === newData) return true;
  if (!oldData || !newData) return false;
  const oldItems = oldData.items;
  const newItems = newData.items;
  if (oldItems.length !== newItems.length) return false;
  for (let i = 0; i < oldItems.length; i++) {
    const a = oldItems[i];
    const b = newItems[i];
    if (
      a.itemId !== b.itemId ||
      a.itemName !== b.itemName ||
      a.window !== b.window ||
      a.status !== b.status ||
      a.isSoundPlayed !== b.isSoundPlayed
    ) {
      return false;
    }
  }
  return true;
};

export const isCreatedTicketsEqual = (
  oldData: CreatedTicketsLike | undefined,
  newData: CreatedTicketsLike | undefined
): boolean => {
  if (oldData === newData) return true;
  if (!oldData || !newData) return false;
  const oldItems = oldData.items;
  const newItems = newData.items;
  if (oldItems.length !== newItems.length) return false;
  for (let i = 0; i < oldItems.length; i++) {
    const a = oldItems[i];
    const b = newItems[i];
    if (a.itemId !== b.itemId || a.itemName !== b.itemName || a.status !== b.status) {
      return false;
    }
  }
  return true;
};
